<ion-content>

  <div class="wrapper">

    <div class="background-image">

      <ion-img [src]="remoteConfigValues.Wallpaper"></ion-img>
      
    </div>

    <div class="present-oval">
      
      <div class="oval">

        <ion-img [src]="remoteConfigValues.Imagen"></ion-img>

      </div>

    </div>

    <div class="content">

      <ion-item class="ion-no-padding title" lines="none">
        <ion-label>{{ remoteConfigValues.Titulo }}</ion-label>
      </ion-item>

      <ion-item class="ion-no-padding description" lines="none">
        <ion-label>{{ remoteConfigValues.Descripcion }}</ion-label>
      </ion-item>

      <ion-item class="ion-no-padding botom" lines="none">
        
        <ion-button size="default" (click)="toDownload()" class="class-buton">
          <ion-label>{{ remoteConfigValues.Boton }}</ion-label>
        </ion-button>

      </ion-item>
      
    </div>

  </div>

</ion-content>
